import React from "react";
import ReactDOM from "react-dom";
import cn from 'classnames'
import { withModels } from "game_play/utils/store";
import { Number } from '../utils'
import ScoreTableBtn from "../scoreTableBtn";
import dartsIcon from '../../static/game/image/darts.svg';

const $scoreTableBtn = document.querySelector('#react-score-table-btn');

class ScoreTable extends React.Component {

  $legsRef = React.createRef()

  renderShots(ss) {
    if (ss?.sectors) {
      return (
        <div className="table__shot-sectors">
          {ss?.sectors.map((shot, i) =>
            <span key={i} className="table__shot-sector">{shot.length >= 2 ?
              <Number value={shot[0] * shot[1]}/> : null}</span>
          )}
        </div>
      )
    } else {
      const score = ss?.score !== undefined ? <Number value={ss.score}/> : null
      return (
        <div className="table__shot-score">
          {ss?.darts ? <>{score} <img src={dartsIcon} alt='darts'
                                      style={{ padding: '0 5px', marginTop: '-5px' }}/>{ss.darts}</> : score}
        </div>
      )
    }
  }

  renderLeg(leg, i, legs, winner_number) {
    const { Game } = this.props;
    const { player_1, player_2 } = Game.get('game')
    const slice_legs = legs.slice(0, i + 1)
    const [score_1, score_2] = Game.calculateTotalScore(slice_legs)
    const first = Game.calculateFirst(slice_legs)

    return (
      <table key={i} className="table score_table">
        <thead>
        <tr>
          <th
            className={cn('p1_name text__left', {
              'score_table__red-circle': first === 0,
              'score_table__winner': winner_number === 1,
            })}
            colSpan="2"
            style={{
              width: '40%'
            }}>{player_1.name}</th>
          <th>
            <div className="score_table__score">
              <span><Number value={score_1}/></span>
              <span style={{ padding: '0 10px' }}>-</span>
              <span><Number value={score_2}/></span>
            </div>
          </th>
          <th
            className={cn('p2_name text__right', {
              'score_table__red-circle': first === 1,
              'score_table__winner': winner_number === 2,
            })}
            colSpan="2"
            style={{
              width: '40%'
            }}>{player_2.name}</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td>Scored</td>
          <td>To Go</td>
          <td></td>
          <td>To Go</td>
          <td>Scored</td>
        </tr>
        <tr>
          <td></td>
          <td>{Game.FINAL_SCORE}</td>
          <td></td>
          <td>{Game.FINAL_SCORE}</td>
          <td></td>
        </tr>
        {leg.map(([ss1, ss2], i) => {
          const slice_leg = leg.slice(0, i + 1)
          return (
            <tr key={i}>
              <td>
                {this.renderShots(ss1)}
              </td>
              <td><Number value={Game.calculateRemainder(slice_leg, 0)}/></td>
              <td>{(i + 1) * 3}</td>
              <td><Number value={Game.calculateRemainder(slice_leg, 1)}/></td>
              <td>
                {this.renderShots(ss2)}
              </td>
            </tr>
          )
        })}
        </tbody>
      </table>
    )
  }

  render() {
    const {Game} = this.props
    const legs = Game.get('game').data;

    return (
      <>
        {ReactDOM.createPortal(
          <ScoreTableBtn table={this.$legsRef} root={$scoreTableBtn}/>,
          $scoreTableBtn
        )}
        <div className="container-spacer match__rounds hide" ref={this.$legsRef}>
          <div className="container-body">
            <h2 className="sub-heading -l">{gettext('Леги')}</h2>
            {legs.map((leg, i) => this.renderLeg(leg, i, legs, Game.getWinnerNumberByLeg(leg)))}
          </div>
        </div>
      </>
    );
  }
}

export default withModels(ScoreTable)